/*
*   List of Action IDs that should be passed from accreditation.reducer.js to scheme.reducer.js
 */

export const IDS = {
    // module
    rcoRequirementsAssessment: 'rcoRequirementsAssessment',

    //paths
    rcoEvidenceGroupsProgressGrid:          'rcoEvidenceGroupsProgressGrid',
    rcoEvidenceGroupDocumentsGrid:          'rcoEvidenceGroupDocumentsGrid',
    rcoEvidenceGroupHistoryGrid:            'rcoEvidenceGroupHistoryGrid',
    rcoEvidenceGroupImprovementStepsGrid:   'rcoEvidenceGroupImprovementStepsGrid',
    rcoEvidenceOwnerCandidates:             'rcoEvidenceOwnerCandidates',
    rcoEvidenceDocRevisionCandidates:       'rcoEvidenceDocRevisionCandidates',

    // states:

    app_accreditation_scheme_requirements_assessment:                                       'app.accreditation.scheme.requirements-assessment',
    app_accreditation_scheme_requirements_assessment_dashboard:                             'app.accreditation.scheme.requirements-assessment.dashboard',
    app_accreditation_scheme_requirements_assessment_evidence_groups:                       'app.accreditation.scheme.requirements-assessment.evidence-groups',
    app_accreditation_scheme_requirements_assessment_evidence_groups_list:                  'app.accreditation.scheme.requirements-assessment.evidence-groups.list',
    app_accreditation_scheme_requirements_assessment_evidence_groups_details:               'app.accreditation.scheme.requirements-assessment.evidence-groups.details',
    app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request:  'app.accreditation.scheme.requirements-assessment.evidence-groups.doc-revision-request',
    app_accreditation_scheme_requirements_assessment_evidence_groups_improvement:           'app.accreditation.scheme.requirements-assessment.evidence-groups.improvement',
    app_accreditation_scheme_requirements_assessment_evidence_groups_history:               'app.accreditation.scheme.requirements-assessment.evidence-groups.history',
};
